module.exports = __webpack_public_path__ + "static/media/18ECA32.2322870a.jpg";